module.exports = __webpack_public_path__ + "static/media/mobile_app.94bbad85.png";